import type { ICatalog } from '@platform/core/types';
import { moduleNav } from '@platform/navigation';

/**
 * Кількість модулів робочого простору для «Переглянути всі N модулів →» Головної: встановлені модулі, що показуються в меню груп (без
 * платформних зв'язків, тегів і календаря) і без системних сторінок — як modListed прототипу v4 (парламент 92, комітет 90).
 * Каталог ще не завантажено — undefined.
 */
export function listedModuleCount(catalog: ICatalog | undefined): number | undefined {
  return catalog ? catalog.modules.filter((m) => m.installed && moduleNav(m.key).listed).length : undefined;
}
